<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row justify="end" align="center" class="mb-4">
          <v-col cols="12" md="4">
            <v-text-field
              v-model="buscarTexto"
              color="secondary"
              background-color="primary"
              rounded
              filled
              placeholder="Buscar"
              append-icon="mdi-magnify"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card class="card" color="primary">
          <v-card-text class="pa-0">
            <v-data-table
              class="primary"
              :headers="headers"
              :items="asignaciones"
              :search="buscarTexto"
              :items-per-page="15"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, 100],
              }"
              :loading="loading"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    idArma: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        { text: 'Nombre Completo', value: 'nombreCompleto', width: '250px', align: 'left' },
        { text: 'CUIP', value: 'CUIP', width: '200px', align: 'left' },
        { text: 'Puesto', value: 'puesto', width: '250px', align: 'left' },
        { text: 'Dependencia', value: 'dependencia', width: '200px', align: 'left' },
      ],
      buscarTexto: '',
      loading: false,
    }
  },

  computed: {
    ...mapGetters('armeria', {
      historialArma: 'getHistorial',
    }),

    asignaciones() {
      if (!this.historialArma || this.historialArma.length === 0) return []

      // Extraer todas las asignaciones del historial
      const asignacionesList = []
      this.historialArma.forEach((arma) => {
        if (arma.Asignaciones && arma.Asignaciones.length > 0) {
          arma.Asignaciones.forEach((asignacion) => {
            asignacionesList.push(asignacion)
          })
        }
      })

      return asignacionesList
    },
  },
}
</script>
